export function buildOwnerTrend(rows, startMs, now = new Date()) {
  const end = new Date(now); end.setHours(0, 0, 0, 0);
  const start = new Date(startMs || Math.min(end.getTime(), ...rows.map(row => row.__ms)));
  start.setHours(0, 0, 0, 0);
  const days = Math.max(1, Math.round((end - start) / 86400000) + 1);
  const step = Math.max(1, Math.ceil(days / 12));
  const buckets = [];
  for (let offset = 0; offset < days; offset += step) {
    const from = new Date(start); from.setDate(from.getDate() + offset);
    const to = new Date(from); to.setDate(to.getDate() + Math.min(step, days - offset));
    buckets.push({ key: from.toISOString(), label: from.toLocaleDateString('es-PA', { day: 'numeric', month: 'short' }), count: rows.filter(row => row.__ms >= from.getTime() && row.__ms < to.getTime()).length });
  }
  return buckets;
}
